import axiosInstance from "../config/API";

const API_ENDPOINT = "/group_data.php";

// List customer history
export const listCustomerHistoryApi = async (filters = {}) => {
  const payload = {
    list_history: true,
    ...(filters.customer_id && { customer_id: filters.customer_id }),
    ...(filters.customer_no && { customer_no: filters.customer_no }),
    // Add these two lines:
    ...(filters.from_date && { from_date: filters.from_date }),
    ...(filters.to_date && { to_date: filters.to_date }),
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("list customer history:", response.data);
  return response.data.body.history || [];
};

// Fetch staff-wise grouped data (today and month collection amounts)
export const fetchStaffGroupedDataApi = async () => {
  const payload = {
    get_staff_grouped_data: true,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("fetch staff grouped data:", response.data);
  return (
    response.data.body || {
      staff_data: [],
      user_data: [],
      month: "",
      date: "",
    }
  );
};

// Fetch grouped customer data (connected, disconnected, total, unpaid boxes)
export const fetchGroupedCustomerDataApi = async () => {
  const payload = {
    get_grouped_customer_data: true,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("fetch grouped customer data:", response.data);
  return (
    response.data.body.grouped_data || {
      connected_boxes: 0,
      disconnected_boxes: 0,
      unpaid_boxes: 0,
      total_boxes: 0,
      connected_boxes_data: [],
      disconnected_boxes_data: [],
      unpaid_boxes_data: [],
      total_boxes_data: [],
    }
  );
};

// Fetch staff-wise grouped counts (box counts, paid/unpaid counts)
export const fetchStaffGroupedCountsApi = async () => {
  const payload = {
    get_staff_grouped_counts: true,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("fetch staff grouped counts:", response.data);
  return (
    response.data.body || {
      staff_grouped_counts: [],
      user_grouped_counts: [],
      month: "",
      date: "",
    }
  );
};

// Fetch login history
export const fetchLoginHistoryApi = async (filters = {}) => {
  const payload = {
    login_history: true,
    ...(filters.search_text && { search_text: filters.search_text }),
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("fetch login history:", response.data);
  return response.data.body.LoginHistory || [];
};

// Fetch monthly/yearly report
export const fetchMonthlyReportApi = async () => {
  const payload = {
    action: "monthly_report",
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("fetch monthly report:", response.data);
  return response.data.body.report || [];
};

/// Fetch unpaid reports
export const fetchUnpaidReportsApi = async (filters = {}) => {
  const payload = {
    unpaid_reports_data: true,
    plan_id: filters.plan_id || "",
    area_id: filters.area_id || "",
    staff_id: filters.staff_id || ""
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("fetch unpaid reports:", response.data);
  return response.data.body?.unpaid_reports?.unpaid_reports_data || [];
};

// Fetch planwise report
export const fetchPlanwiseReportApi = async (filters = {}) => {
  const payload = {
    plan_wise_report: true,
    plan_id: filters.plan_id || "",
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("fetch planwise report:", response.data);
  return response.data.body?.plan_wise_report || [];
};